<template>
	<div class="field-wrap">
		<label v-if="label" :for="name" class="field-wrap__label"
			>{{ label }}{{ req }}</label
		>
		<div class="field-wrap__input">
			<slot />
		</div>
		<p class="field-wrap__error" v-if="error">{{ error }}</p>
		<p class="field-wrap__info" v-else-if="info">{{ info }}</p>
	</div>
</template>

<script>
export default {
	name: 'field-wrapper',
	props: {
		name: String,
		label: String,
		info: String,
		error: String,
		required: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		req() {
			return this.required ? '*' : ''
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/components';

.field-wrap {
	&__label {
		@extend %field-label;
		margin-bottom: 0.75rem;
	}
	&__error {
		@extend %field-error;
		margin: 0.25rem 0 0;
	}
	&__info {
		@extend %field-info;
		margin: 0.25rem 0 0;
	}
	&__input {
		position: relative;
	}
}
</style>
